import { HomepageSectionItem } from '../../../redux-toolkits/home-page-v2.1/homePageV21.type'
import './list-menu-preview.css'

export const ListMenuPreview = ({
  items,
  title,
  description,
}: {
  items: HomepageSectionItem[]
  title?: string
  description?: string
}) => (
  <section className="list-menu-preview">
    {title || description ? (
      <header className="list-menu-preview__header">
        {title ? <h2 className="list-menu-preview__title">{title}</h2> : null}
        {description ? (
          <p className="list-menu-preview__description">{description}</p>
        ) : null}
      </header>
    ) : null}
    <div className="list-menu-preview__cards">
      {items.map((entry, index) => {
        const menu = typeof entry.item === 'object' ? entry.item : {}
        return (
          <article className="list-menu-preview__card" key={entry._id || index}>
            {menu?.banner ? (
              <img
                alt=""
                src={menu.banner}
                className="list-menu-preview__image"
              />
            ) : null}
            <div className="list-menu-preview__overlay" />
            <div className="list-menu-preview__caption">
              <h3 className="list-menu-preview__name">{menu?.name}</h3>
              <p className="list-menu-preview__details">
                {menu?.description ? `${menu.description} · ` : ''}
                {menu?.listCount ?? 0}{' '}
                {menu?.listCount === 1 ? 'list' : 'lists'}
              </p>
            </div>
          </article>
        )
      })}
    </div>
  </section>
)
